import AnalyticsContext, {
  AnalyticsProvider,
  type ContextType,
} from './reactProvider';
import { startTrackingWithoutPayload } from './startTracking';
import type WeapiEventPayload from './contracts/weapiEventPayload';
import type { EventOverrides, EnvelopeOptions } from './contracts';

const startTracking = startTrackingWithoutPayload;

export {
  startTracking as default,
  AnalyticsProvider,
  AnalyticsContext,
  ContextType,
  WeapiEventPayload,
  EventOverrides,
  EnvelopeOptions,
};
